/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Theme_Atlas_LabelInputs */

const bn_theme_atlas_label = /** @type {(inputs: Theme_Atlas_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এটলাস`)
};

const de_theme_atlas_label = /** @type {(inputs: Theme_Atlas_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atlas`)
};

const el_theme_atlas_label = /** @type {(inputs: Theme_Atlas_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ατλας`)
};

const en_theme_atlas_label = /** @type {(inputs: Theme_Atlas_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atlas`)
};

const es_theme_atlas_label = /** @type {(inputs: Theme_Atlas_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atlas`)
};

const fr_theme_atlas_label = /** @type {(inputs: Theme_Atlas_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atlas`)
};

const hi_theme_atlas_label = /** @type {(inputs: Theme_Atlas_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एटलस`)
};

const hu_theme_atlas_label = /** @type {(inputs: Theme_Atlas_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atlasz`)
};

const id_theme_atlas_label = /** @type {(inputs: Theme_Atlas_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atlas`)
};

const it_theme_atlas_label = /** @type {(inputs: Theme_Atlas_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atlante`)
};

const ja_theme_atlas_label = /** @type {(inputs: Theme_Atlas_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アトラス`)
};

const ko_theme_atlas_label = /** @type {(inputs: Theme_Atlas_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아틀라스`)
};

const nl_theme_atlas_label = /** @type {(inputs: Theme_Atlas_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atlas`)
};

const pl_theme_atlas_label = /** @type {(inputs: Theme_Atlas_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atlas`)
};

const pt_theme_atlas_label = /** @type {(inputs: Theme_Atlas_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atlas`)
};

const ru_theme_atlas_label = /** @type {(inputs: Theme_Atlas_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Атлас`)
};

const sv_theme_atlas_label = /** @type {(inputs: Theme_Atlas_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atlas`)
};

const tr_theme_atlas_label = /** @type {(inputs: Theme_Atlas_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atlas`)
};

const uk_theme_atlas_label = /** @type {(inputs: Theme_Atlas_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Атлас`)
};

const vi_theme_atlas_label = /** @type {(inputs: Theme_Atlas_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tập bản đồ`)
};

const zh_theme_atlas_label = /** @type {(inputs: Theme_Atlas_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`阿特拉斯`)
};

const zh_hant_theme_atlas_label = /** @type {(inputs: Theme_Atlas_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`阿特拉斯`)
};

/**
* | output |
* | --- |
* | "Atlas" |
*
* @param {Theme_Atlas_LabelInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const theme_atlas_label = /** @type {((inputs?: Theme_Atlas_LabelInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Theme_Atlas_LabelInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_theme_atlas_label(inputs)
	if (locale === "de") return de_theme_atlas_label(inputs)
	if (locale === "el") return el_theme_atlas_label(inputs)
	if (locale === "en") return en_theme_atlas_label(inputs)
	if (locale === "es") return es_theme_atlas_label(inputs)
	if (locale === "fr") return fr_theme_atlas_label(inputs)
	if (locale === "hi") return hi_theme_atlas_label(inputs)
	if (locale === "hu") return hu_theme_atlas_label(inputs)
	if (locale === "id") return id_theme_atlas_label(inputs)
	if (locale === "it") return it_theme_atlas_label(inputs)
	if (locale === "ja") return ja_theme_atlas_label(inputs)
	if (locale === "ko") return ko_theme_atlas_label(inputs)
	if (locale === "nl") return nl_theme_atlas_label(inputs)
	if (locale === "pl") return pl_theme_atlas_label(inputs)
	if (locale === "pt") return pt_theme_atlas_label(inputs)
	if (locale === "ru") return ru_theme_atlas_label(inputs)
	if (locale === "sv") return sv_theme_atlas_label(inputs)
	if (locale === "tr") return tr_theme_atlas_label(inputs)
	if (locale === "uk") return uk_theme_atlas_label(inputs)
	if (locale === "vi") return vi_theme_atlas_label(inputs)
	if (locale === "zh") return zh_theme_atlas_label(inputs)
	return zh_hant_theme_atlas_label(inputs)
});